module.exports = __webpack_public_path__ + "static/media/birds-eye-village-annotated-mobile-hitboxed-01.64fcb4da.svg";